import {
  getAccessToken,
  onUnauthorized as onUnauthorizedCallBack,
} from './auth';
import { ApiConfig, HttpResponse, RequestParams } from './client/http-client';

let onUnauthorized = onUnauthorizedCallBack;

let customFetch: typeof fetch = async (
  ...fetchParams: Parameters<typeof fetch>
) => {
  // Try to perform request
  try {
    const response = await fetch(...fetchParams);

    // Check if request failed
    if (response.status < 200 || response.status > 299) {
      throw response;
    }
    // Request was successfull. Nothing needs to be done just return the response
    return response;
  } catch (responseError) {
    // The request failed :-(
    const errorResponse = responseError as HttpResponse<any, any>;

    // Let's check if the resposne status was unauthorized
    if (errorResponse.status === 401) {
      // Resposne was uanauthorized so let's call the onUnauthorized
      onUnauthorized();
    }

    // The response was not unauthorized, rethrow the error
    throw responseError;
  }
};

export async function setOnUnauthorized(
  onUnauthorizedCallBack: typeof onUnauthorized,
) {
  onUnauthorized = onUnauthorizedCallBack;
}

const securityWorker = (): RequestParams => {
  const accessToken = getAccessToken();

  return {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  };
};
export const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
export const bookingApiURL =
  process.env.REACT_APP_BOOKING_API_URL || 'http://localhost:8080';

export const importCustomersURL =
  process.env.REACT_APP_IMPORT_API_URL || 'http://localhost:8080';

export const colaboratorsURL = bookingApiURL + '/colaborators';
export const customersURL = bookingApiURL + '/customers';
export const servicesURL = bookingApiURL + '/services';
export const bookingsURL = bookingApiURL + '/bookings';
export const defaultApiConfig: ApiConfig<any> = {
  customFetch,
  securityWorker,
  baseUrl,
};

export const defaultBookingApiConfig: ApiConfig<any> = {
  customFetch,
  securityWorker,
  baseUrl: bookingApiURL,
};
